module.exports = __webpack_public_path__ + "media/images/home-splash-cd9261815f1afa1499d7ea9a3fe06909.jpg";